import { render, staticRenderFns } from "./DocumentTypeTemplateComponent.vue?vue&type=template&id=40f903e0&lang=pug"
import script from "./DocumentTypeTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./DocumentTypeTemplateComponent.vue?vue&type=script&lang=ts"
import style0 from "./DocumentTypeTemplateComponent.vue?vue&type=style&index=0&id=40f903e0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40f903e0')) {
      api.createRecord('40f903e0', component.options)
    } else {
      api.reload('40f903e0', component.options)
    }
    module.hot.accept("./DocumentTypeTemplateComponent.vue?vue&type=template&id=40f903e0&lang=pug", function () {
      api.rerender('40f903e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/ColumnTemplates/DocumentTypeTemplateComponent.vue"
export default component.exports